import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Alert } from 'rsuite';
import { AlertWithTimestamp } from '../../../../../../components/AlertWithTimestamp';
import { Exception } from '../../../../../../data';
import { getSetupIPADadosDeConcorrencia, postSetupIPADadosDeConcorrencia, upadateSetupIPADadosDeConcorrencia } from '../services';

const QUERY_KEY = ['ipa/setup-form/competitor-days'];

export const useSetupIPAConfig = () => {
  const queryClient = useQueryClient();

  const configQuery = useQuery({
    queryKey: QUERY_KEY,
    queryFn: getSetupIPADadosDeConcorrencia,
  });

  const { mutateAsync: createConfig, isLoading: isCreating } = useMutation({
    mutationFn: postSetupIPADadosDeConcorrencia,
    onSuccess: () => {
      Alert.success('Configurações salvas com sucesso');
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
    onError: () => {
      const { message } = new Exception('Erro ao salvar as configurações');
      AlertWithTimestamp({ message });
    },
  });

  const { mutateAsync: updateConfig, isLoading: isUpdating } = useMutation({
    mutationFn: upadateSetupIPADadosDeConcorrencia,
    onSuccess: () => {
      Alert.success('Configurações salvas com sucesso');
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
    onError: () => {
      const { message } = new Exception('Erro ao salvar as configurações');
      AlertWithTimestamp({ message });
    },
  });

  return {
    data: configQuery.data,
    error: configQuery.error,
    isLoading: configQuery.isLoading,
    isSaving: isCreating || isUpdating,
    refetch: configQuery.refetch,
    createConfig,
    updateConfig,
  };
};
